import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchFestivals'
})

export class SearchFestivalsPipe implements PipeTransform {

  transform(pipeData, pipeModifier): any {
    return pipeData.filter(eachItem => {
      if (pipeModifier != 'FESTIVAL/PROGRAM') {
        pipeModifier = pipeModifier.toLowerCase().replace(/-/g, ' ')
        if (eachItem['fields']['festival'] !== undefined) {
          if (Array.isArray(eachItem['fields']['festival'])) {
            var arrayOfFestivals = eachItem['fields']['festival'].map(v => v.toLowerCase());

            if (arrayOfFestivals.includes(pipeModifier)) {
              return eachItem['fields']['festival']
            }
          } else {
            return eachItem['fields']['festival'].toLowerCase().includes(pipeModifier)
          }
        }
      } else {
        return eachItem
      }
    });
  }

}